import firebase from "../services/firebase";

const logOut = () => {
  return firebase.auth().signOut();
};
export { logOut };
